import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'blaze-form';
import CustomerSearch from './CustomerSearch';
import LocalCustomerSearch from './LocalCustomerSearch';
import LoyaltyContext from './LoyaltyContext';

// res hushes TS inference problems
// eslint-disable-next-line
const CustomerSelect = ({ onSelect = res => {}, dealerCustomerNum = '' }) => {
  const [hasLocalCustomers, setHasLocalCustomers] = useState(null);
  const { fetchLocalCustomers } = useContext(LoyaltyContext);

  useEffect(() => {
    if (dealerCustomerNum) {
      fetchLocalCustomers({ customerNum: dealerCustomerNum }).then(({ data }) => {
        if (data && data.length) {
          setHasLocalCustomers(true);
        }
      });
    }
  }, [dealerCustomerNum]);

  const renderLocalCustomerSearch = () => {
    // only show if local customers exists in the database
    if (!dealerCustomerNum || !hasLocalCustomers) {
      return null;
    }

    return (
      <FormSection title="Quick Search">
        <LocalCustomerSearch onSelect={onSelect} customerNum={dealerCustomerNum} />
      </FormSection>
    );
  };

  return (
    <div className="customer-select">
      {renderLocalCustomerSearch()}
      <FormSection title="Search Loyalty Customer">
        <CustomerSearch onSelect={onSelect} />
      </FormSection>
    </div>
  );
};

CustomerSelect.propTypes = {
  dealerCustomerNum: PropTypes.string,
  onSelect: PropTypes.func,
};

export default CustomerSelect;
